import { render, staticRenderFns } from "./MainFlourInput.vue?vue&type=template&id=728fb3c2&scoped=true&"
import script from "./MainFlourInput.vue?vue&type=script&lang=ts&"
export * from "./MainFlourInput.vue?vue&type=script&lang=ts&"
import style0 from "./MainFlourInput.vue?vue&type=style&index=0&id=728fb3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fb3c2",
  null
  
)

export default component.exports